import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import useWorkflowGuard from 'hooks/useWorkflowGuard';

const CollateralReturnOnTheWay = ({
  navigate,
  searchParams,
}) => {
  useWorkflowGuard(searchParams, navigate);
  const checkinData = useSelector((state) => get(state, 'workflow.data'));
  const walletAddress = get(checkinData, 'address');
  const collateralValue = get(checkinData, 'quantity');
  const collateralCoin = (get(checkinData, 'coin') || '').toUpperCase();

  return (
    <div>
      <div className="md:w-[94%] mx-auto">
        <div className="mb-6">
          <p className="text-sm text-slate-800 text-center">
            Your collateral return has been initiated. Your
            {' '}
            <span className="font-semibold">
              {collateralValue} {collateralCoin}
            </span>
            {' '}
            will be sent to the wallet address provided.
          </p>
        </div>

        <div className="bg-slate-50 rounded-lg border border-slate-200 flex flex-col p-3 justify-between items-center gap-3 mb-6">
          <h2 className="text-slate-500 font-semibold text-base">Destination Wallet</h2>
          <p className="text-sm">{walletAddress}</p>
        </div>
      </div>

      <div className="mb-6 px-4 py-6 bg-yellow-50 rounded text-sm text-center">
        You will receive an email with the final transaction details when the transfer is complete.
      </div>
    </div>
  );
};

CollateralReturnOnTheWay.propTypes = {
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default CollateralReturnOnTheWay;
